import { Component } from '@angular/core';
import {
  DURATION_KPI_PANEL_IMPORTS,
  DurationKpiPanelComponent,
} from 'src/app/panels/components/kpi/duration-kpi-panel/duration-kpi-panel.component';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';
import { PanelComponent } from '../../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../../panels/components/kpi/duration-kpi-panel/duration-kpi-panel.component.html',
  styleUrl: '../../../../../panels/components/kpi/duration-kpi-panel/duration-kpi-panel.component.scss',
  selector: 'app-available-sunlight-kpi-panel',
  imports: DURATION_KPI_PANEL_IMPORTS,
})
export class AvailableSunlightKpiPanelComponent extends DurationKpiPanelComponent {
  public static override readonly type = PanelType.AvailableSunlightKpi;
  public override title = `Beschikbare zonuren`;
  public override icon = 'bi-sun';
  public override unit = DisplayUnit.None;
  public override color = Color.Orange;
}
